// Config
import { validateBillingAddress, validatePostcodeSearch } from './paymentActions';
import {
  KLARNA_CANCEL,
  KLARNA_ERROR,
  KLARNA_INITIALISE_ERROR,
  KLARNA_LOAD_COMPLETE,
  KLARNA_PAYMENT_STARTED,
  KLARNA_SAVE_CARD,
  KLARNA_SCRIPT_LOADING,
  KLARNA_SCRIPT_LOADED,
  KLARNA_SCRIPT_FAILED,
  KLARNA_STUBS_MODAL_OPEN,
  KLARNA_STUBS_MODAL_CLOSE,
  KLARNA_PAYMENT_VISIBLE,
  KLARNA_ENABLED_STATUS,
  KLARNA_SDK_SCRIPT_LOADING,
  KLARNA_SDK_SCRIPT_FAILED,
  KLARNA_SDK_SCRIPT_LOADED,
} from '../../../constants/actionConstants';
import { loadScript } from '../../../utils';

export const loadKlarnaScript = () => async (dispatch, getState) => {
  const state = getState();

  if (state.payment.klarnaScriptLoading) return;

  if (state.payment.klarnaScriptLoaded) return;

  if (state.payment.klarnaScriptFailed) return;

  await dispatch({
    type: KLARNA_SCRIPT_LOADING,
  });

  const onErrorCallback = () => {
    dispatch({
      type: KLARNA_SCRIPT_FAILED,
    });
  };

  const klarnaScriptUrl = window.env.KLARNA_SCRIPT_URL;

  loadScript({
    url: klarnaScriptUrl,
    async: true,
    onErrorCallback,
    onSuccessCallback: () => {
      dispatch({
        type: KLARNA_SCRIPT_LOADED,
      });
    },
  })();
};

export const loadKlarnaSdkScript = () => async (dispatch, getState) => {
  const state = getState();

  if (state.payment.klarnaSdkScriptLoading) return;

  if (state.payment.klarnaSdkScriptLoaded) return;

  if (state.payment.klarnaSdkScriptFailed) return;

  await dispatch({
    type: KLARNA_SDK_SCRIPT_LOADING,
  });

  const onErrorCallback = () => {
    dispatch({
      type: KLARNA_SDK_SCRIPT_FAILED,
    });
  };

  const scriptUrl = window.env.KLARNA_WEB_SDK_SCRIPT_URL;
  const environment = window.env.KLARNA_WEB_SDK_ENVIRONMENT;
  const clientId = window.env.KLARNA_WEB_SDK_CLIENT_ID;

  loadScript({
    url: scriptUrl,
    async: true,
    attributes: {
      'data-environment': environment,
      'data-client-id': clientId,
    },
    onErrorCallback,
    onSuccessCallback: () => {
      dispatch({
        type: KLARNA_SDK_SCRIPT_LOADED,
      });
    },
  })();
};

export const openKlarnaStubsModal = () => ({
  type: KLARNA_STUBS_MODAL_OPEN,
});

export const closeKlarnaStubsModal = () => ({
  type: KLARNA_STUBS_MODAL_CLOSE,
});

export const saveVirtualKlarnaCard = virtualCard => ({
  type: KLARNA_SAVE_CARD,
  virtualCard,
});

export const handleKlarnaCancel = () => ({
  type: KLARNA_CANCEL,
});

export const klarnaPaymentStarted = () => ({
  type: KLARNA_PAYMENT_STARTED,
});

export const klarnaPaymentVisible = (visible = false) => ({
  type: KLARNA_PAYMENT_VISIBLE,
  visible,
});

export const klarnaLoadComplete = () => ({
  type: KLARNA_LOAD_COMPLETE,
});

export const handleKlarnaError = error => ({
  type: KLARNA_ERROR,
  error,
});

export const handleKlarnaInitialiseError = error => ({
  type: KLARNA_INITIALISE_ERROR,
  error,
});

export const handleKlarnaFormErrors = () => async (dispatch) => {
  dispatch(validateBillingAddress());
  dispatch(validatePostcodeSearch());
};

export const setKlarnaEnabledStatus = enabled => ({
  type: KLARNA_ENABLED_STATUS,
  enabled,
});
